
import { toast } from "@/components/ui/use-toast";
import { fileStorage } from "@/utils/fileStorage";
import { FileItem } from "../types";

export const useFileDelete = (files: FileItem[], setFiles: React.Dispatch<React.SetStateAction<FileItem[]>>) => {
  const handleDeleteFile = (fileId: number) => {
    const fileToDelete = files.find(f => f.id === fileId);
    // Use our fileStorage utility to delete the file
    fileStorage.deleteFile(fileId);
    setFiles(files.filter(file => file.id !== fileId));
    
    toast({
      title: "Επιτυχία",
      description: `Το αρχείο "${fileToDelete?.name}" διαγράφηκε επιτυχώς`
    });
  };

  return { handleDeleteFile };
};
